import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';
import type { LocationSitemapPageDataErrorCode } from './types';

export const {
	Context: LocationSitemapPageDataContext,
	Provider: LocationSitemapPageDataContextProvider,
	useContext: useLocationSitemapPageData,
	useAsyncData: useLocationSitemapPageDataFromApi,
	prefetchAsyncData: prefetchLocationSitemapPageDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocationSitemapPageDataContext',
	dataProperty: 'pageData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: ({ stateCode }) => stateCode || '',
	hookDeps: ({ stateCode }) => [stateCode],
	errorHandler: pageDataErrorHandler<LocationSitemapPageDataErrorCode>(),
});
